import { Modal, Empty } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";

import { useLoading } from "components/GlobalLoading/index";
import useHistoricoEquipamento from "features/equipamento/hooks/useHistoricoEquipamento";
import Historico from "./components/Historico";

interface ModalHistoricoEquipamentoProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
}

export default function ModalHistoricoEquipamento({
  id,
  isOpenModal,
  onClose,
}: ModalHistoricoEquipamentoProps) {
  const { data, isFetching } = useHistoricoEquipamento(id);

  useLoading(isFetching);

  return (
    <Modal
      visible={isOpenModal}
      onCancel={onClose}
      centered
      footer={
        <Flex flex={1} justifyContent="end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
        </Flex>
      }
    >
      <Historico logs={data ?? []} />
      {!data?.length && !isFetching ? (
        <Empty description="Sem dados de histórico para essa equipamento" />
      ) : null}
    </Modal>
  );
}
